import VisualAnalysisListStore from './visual.list';

export const visualAnalysis = {
  list: VisualAnalysisListStore
};
